export default "__VITE_ASSET__mxcxydjw__"